export default class QuotesStep {
  static INTRODUCTION = "quote-introduction";
  static QUESTIONS = "quote-questions";
  static QUOTE = "quote-quote";
  static ADDON = "quote-addon";
  static ACCOUNT = "quote-account";
  static CHECKOUT = "quote-checkout";
  static REVIEW = "quote-review";
  static DONE = "quote-done";
}
